import React from "react";
import "./main-button-styles.css";
const MainButton = ({ children, styles, text, onClick }) => {
  return (
    <div className="mainButtonWrapper" style={styles} onClick={onClick}>
      {children}
      <p>{text}</p>
    </div>
  );
};

export default MainButton;
